<template>
  <not-auth
    v-if="getActiveUser.userInfo.role !== 'Admin' && !isPermission"
  ></not-auth>
  <div v-else class="container-fluid">
    <ProjectInfo
      v-if="isZipping"
      @pdf-created="updatePdfOfProject($event, 'project')"
      :project="project"
    ></ProjectInfo>
    <EvaporatorBatteryInfo
      v-if="isZipping"
      @pdf-created="updatePdfOfProject($event, 'evaporator')"
      :project="project"
    ></EvaporatorBatteryInfo>
    <CondenserBatteryInfo
      v-if="isZipping"
      @pdf-created="updatePdfOfProject($event, 'condenser')"
      :project="project"
    ></CondenserBatteryInfo>
    <div class="row" :class="!hideTree ? '' : 'u-padding-xsmall'">
      <div
        v-if="!hideTree"
        class="es-xs-12 es-sm-3 col-sticky u-top-0 u-background-color-light-muted"
      >
        <ul class="c-list">
          <li
            class="c-list__item u-line-1"
            v-for="(path, index) in splitPath"
            @click="openFile({ title: path, type: 'Folder' }, true)"
            :key="index"
          >
            <div :style="`margin-left:${index * 5}px`">
              <i class="icofont-folder u-color-warning"></i> {{ path }}
            </div>
          </li>
          <loading v-if="isLoading"></loading>
          <li
            v-show="!isLoading"
            @click="openFile(file)"
            class="c-list__item u-line-1"
            v-for="(file, index) in files"
            :key="index"
          >
            <div :style="`margin-left:${splitPath.length * 5}px`">
              <i
                class="icofont-folder u-color-warning"
                v-if="file.type === 'Folder'"
              ></i>
              <i
                v-else
                :class="`icofont-${file.icon} `"
                :style="`color: ${file.color}`"
              ></i>
              {{ file.title }}
            </div>
          </li>
        </ul>
      </div>
      <div class="es-xs-12" :class="!hideTree ? 'es-sm-9' : 'es-sm-12'">
        <loading v-if="isLoading"></loading>
        <div v-else class="container-fluid">
          <div class="row u-align-items-center u-justify-content-center">
            <h5
              v-if="!hideTree"
              class="es-xs-12 u-background-color-light-muted u-padding-xsmall"
            >
              <i
                class="icofont-arrow-left u-color-danger u-cursor-pointer"
                @click="goBack"
              ></i>
              {{ splitPath.length > 1 ? splitPath[splitPath.length - 1] : "" }}
              <span class="u-color-muted"> {{ files.length }}</span>
              <Button
                class="u-margin-left-xsmall"
                variant="light-warning"
                @click="startZipping"
                size="sm"
              >
                <i class="icofont-file-zip"></i> {{ $t("common.export") }}
              </Button>
            </h5>
            <div
              class="es-xs-12 u-display-flex u-justify-content-flex-end u-align-items-center"
            >
              <div
                v-if="project.isPermission"
                class="btn-group-container u-justify-content-flex-end u-margin-right-xsmall"
              >
                <Button
                  group-item
                  @click="setFileType('active')"
                  :variant="`${
                    fileType === 'active' ? 'primary' : 'light-primary'
                  }`"
                >
                  {{ $t("common.active") }}
                </Button>
                <Button
                  group-item
                  @click="setFileType('passive')"
                  :variant="`${
                    fileType === 'passive' ? 'primary' : 'light-primary'
                  }`"
                >
                  {{ $t("common.inactive") }}
                </Button>
              </div>
              <Button
                class="u-margin-right-xsmall"
                variant="light-warning"
                size="sm"
                @click="startZipping"
              >
                <i class="icofont-file-zip"></i> {{ $t("common.export") }}
              </Button>
              <BaseInput
                icon="search"
                size="sm"
                :placeholder="$t('common.search')"
                v-model="search"
              ></BaseInput>
            </div>
            <div class="es-xs-12" v-if="filteredFiles.length === 0">
              <div class="u-text-align-center">
                <i class="icofont-folder u-color-warning u-font-size-huge"></i>
                <div class="u-line-1 u-color-primary">
                  <small>{{ $t("common.noFileInFileManager") }}</small>
                </div>
                <div class="u-margin-top u-margin-bottom">
                  <i class="icofont-arrow-down"></i>
                </div>
              </div>
            </div>
            <div class="es-xs-12">
              <ul class="c-list" v-if="project.id">
                <li @click="setSuggestions(null)" class="c-list__item u-line-1">
                  <div>
                    <i class="icofont-plus"></i>
                    <small>{{ $t("common.newFile") }}</small>
                  </div>
                  <input
                    ref="fileUpload"
                    type="file"
                    class="u-display-none"
                    @change="uploadFile"
                  />
                </li>
              </ul>
              <ul class="c-list" v-for="(file, i) in filteredFiles" :key="i">
                <h4
                  v-if="
                    i === 0 ||
                    file.projectTag.id !== filteredFiles[i - 1].projectTag.id
                  "
                  class="u-padding-bottom-xsmall u-padding-top-xsmall u-color-primary"
                >
                  {{ file.projectTag.title }} ({{ $t(`common.${fileType}`) }})
                  <Button
                    class="u-margin-left-xsmall"
                    variant="warning"
                    size="sm"
                    @click="setSuggestions(file.projectTag)"
                  >
                    {{ $t("common.updateFile") }}
                  </Button>
                </h4>
                <li
                  class="c-list__item u-padding-right-xsmall u-padding-left-xsmall"
                >
                  <div @click="downloadFile(file)">
                    <i
                      :class="`icofont-${file.icon}`"
                      :style="`color: ${file.color}`"
                    ></i>
                    {{ file.title }}
                    <div>
                      <small>{{ $date.format(file.createdDate) }}</small>
                      -
                      <small> {{ file.user.fullname }} </small>
                    </div>
                  </div>
                  <div>
                    <Button
                      class="u-margin-left-xsmall"
                      v-if="!file.isActive"
                      variant="info"
                      v-tooltip="$t('uploadFile.activate')"
                      size="sm"
                      @click="activateFile(file)"
                      ><i class="icofont-refresh"></i
                    ></Button>
                    <Button
                      class="u-margin-left-xsmall"
                      variant="light-warning"
                      size="sm"
                      @click="downloadFile(file)"
                      ><i class="icofont-download"></i
                    ></Button>
                    <Button
                      class="u-margin-left-xsmall"
                      variant="light-danger"
                      size="sm"
                      @click="deleteFileData = { status: true, item: file }"
                      ><i class="icofont-trash"></i
                    ></Button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RemoveModal
      v-model="deleteFileData.status"
      @ok="deleteFile(deleteFileData.item)"
    ></RemoveModal>
    <UploadFile
      v-model="isUploading"
      @upload="uploadFile"
      :init-suggestions="suggestions"
    ></UploadFile>
  </div>
</template>

<script>
import { getFileTypeInfo } from "@/helpers/fileType";
import Requests from "@/services/Requests";
import { mapGetters } from "vuex";
import Button from "@/components/Base/Button.vue";
import BaseInput from "../Base/Inputs/BaseInput.vue";
import ProjectInfo from "./Pdfs/ProjectInfo.vue";
import EvaporatorBatteryInfo from "./Pdfs/EvaporatorBatteryInfo.vue";
import CondenserBatteryInfo from "./Pdfs/CondenserBatteryInfo.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import UploadFile from "./UploadFile.vue";

export default {
  components: {
    Button,
    BaseInput,
    ProjectInfo,
    EvaporatorBatteryInfo,
    CondenserBatteryInfo,
    RemoveModal,
    UploadFile,
  },
  data() {
    return {
      fileType: "active",
      isZipping: false,
      updatedPdf: [],
      isLoading: true,
      path: this.startPath,
      files: [],
      search: "",
      suggestions: [],
      deleteFileData: {
        status: false,
        item: null,
      },
      isUploading: false,
    };
  },
  props: {
    isPermission: {
      type: Boolean,
      default: false,
    },
    startPath: {
      type: String,
      default: "",
    },
    col: {
      type: String,
      default: "3",
    },
    hideTree: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["getActiveUser"]),
    splitPath() {
      return this.path.split("/");
    },
    filteredFiles() {
      return this.files.filter((file) =>
        file.title.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  watch: {
    "$route.query"(query) {
      this.path = query.path || "";
      this.getDirectoriesAndFiles();
    },
  },
  mounted() {
    if (this.$route.query.path) this.path = this.$route.query.path;
    this.getDirectoriesAndFiles();
  },
  methods: {
    setSuggestions(suggestion) {
      this.suggestions = suggestion ? [suggestion] : [];
      this.isUploading = true;
    },
    getSuggestions(value) {
      return Requests.ProjectTag.GetAll({ query: { search: value } });
    },
    setFileType(type) {
      this.fileType = type;
      this.getDirectoriesAndFiles();
    },
    async activateFile(file) {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.uploading"),
        duration: 20 * 60 * 1000,
      });
      const response = await Requests.ProjectFileLog.ActivateFileLog({
        id: file.id,
      });
      if (response.message === "OK") {
        this.getDirectoriesAndFiles();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("common.addedSuccessfully"),
          variant: "success",
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
        });
      }
    },
    goBack() {
      this.path = this.path.split("/").slice(0, -1).join("/");
      this.$router.push({ query: { path: this.path } });
    },
    openFile(file, isBack = false) {
      if (file.type === "File") return this.downloadFile(file);
      if (isBack) {
        const findPathIndex = this.splitPath.findIndex(
          (path) => path === file.title
        );
        this.path = this.splitPath.slice(0, findPathIndex).join("/");
      } else if (!this.path) this.path = file.title;
      else {
        this.path = this.path + "/" + file.title;
      }
      this.$router.push({ query: { path: this.path } });
    },
    async getDirectoriesAndFiles() {
      this.isLoading = true;
      if (this.project.id) return this.getProjectFiles();
      const response = await Requests.ProjectFileLog.GetDirectoriesAndFiles({
        query: { path: this.path },
      });
      if (response.message === "OK") {
        this.files = response.data.map((file) => ({
          ...file,
          ...getFileTypeInfo(file.title),
        }));
      }
      this.isLoading = false;
    },
    startZipping() {
      this.isZipping = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.projectSynchronizing"),
        duration: 20 * 60 * 1000,
      });
      this.updatedPdf = [
        { status: false, type: "evaporator", file: null },
        { status: false, type: "condenser", file: null },
        { status: false, type: "project", file: null },
      ];
    },
    async updatePdfOfProject(file, type) {
      this.updatedPdf = this.updatedPdf.map((pdf) =>
        pdf.type === type ? { ...pdf, status: true, file } : pdf
      );
      if (this.updatedPdf.every((pdf) => pdf.status)) this.compressFile();
    },
    async compressFile() {
      // if (this.files.length === 0) return;
      this.isZipping = true;

      if (this.updatedPdf.some((pdf) => !pdf.status)) return;

      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: false,
        status: false,
      });
      this.isZipping = false;
      this.$store.commit("SET_DOWNLOAD_ACTION", {
        folderPath: this.path,
        percentage: 0,
        totalFiles: this.files.length,
        currentFile: 1,
        userId: this.getActiveUser.userInfo.id,
        error: "",
        fileName: `${this.path.replace("/", "_")}.zip`,
      });

      const fd = new FormData();
      fd.append("folderPath", this.path);
      this.updatedPdf.forEach((pdf) => {
        fd.append("files", pdf.file);
      });
      Requests.ProjectFileLog.CompressFile(fd).then((response) => {
        const url = response;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${this.path.replace("/", "_")}.zip`);
        document.body.appendChild(link);
        link.click();
        this.$store.commit("REMOVE_DOWNLOAD_ACTION", {
          folderPath: this.path,
          userId: this.getActiveUser.userInfo.id,
        });
      });
    },
    async downloadFile(file) {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.downloading"),
        duration: 20 * 60 * 1000,
      });
      const response = await Requests.ProjectFileLog.DownloadFile({
        query: { fileName: file.title, path: this.path },
      });
      const url = response;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file.title);
      document.body.appendChild(link);
      link.click();
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: false,
        status: false,
      });
    },
    async uploadFile({ file, tags }, isCreatedPdf = false) {
      if (file.size > 25 * 1024 * 1024) {
        return this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("uploadFile.maxLimit", { limit: 25 }),
          variant: "danger",
        });
      }
      if (tags.length === 0) {
        return this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("uploadFile.selectTagInfo"),
          variant: "danger",
        });
      }
      let tag = tags[0];
      if (!tag.id) {
        const response = await Requests.ProjectTag.Create({
          title: tag.title,
        });
        if (response.message === "OK")
          tag = {
            id: response.data,
            title: tag.title,
          };
        else
          return this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: true,
            message: this.$t("uploadFile.errorCreateTag"),
            variant: "danger",
          });
      }
      const fd = new FormData();
      fd.append("file", file);
      fd.append("folderType", "Project");
      fd.append("projectTagId", tag.id);
      fd.append("projectId", this.project.id);
      if (!isCreatedPdf)
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
          message: this.$t("common.uploading"),
          duration: 20 * 60 * 1000,
        });

      const response = await Requests.ProjectFileLog.UploadFile(fd);
      if (response.message === "OK") {
        this.getDirectoriesAndFiles();
        this.suggestions = [];
        if (!isCreatedPdf)
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: true,
            message: this.$t("common.addedSuccessfully"),
            variant: "success",
          });
        this.isUploading = false;
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
        });
      }
      return response;
    },
    async deleteFile(file) {
      this.deleteFileData.status = false;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.removing"),
        duration: 20 * 60 * 1000,
      });
      const response = await Requests.ProjectFileLog.DeleteFile({
        fileName: file.title,
        path: this.path,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("common.removeSuccess"),
          variant: "success",
        });
        this.getDirectoriesAndFiles();
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
        });
      }
    },
    async getProjectFiles() {
      const response = await Requests.ProjectFileLog.GetAll({
        query: {
          projectId: this.project.id,
          isActive: this.fileType === "active" ? "true" : "false",
        },
      });
      this.files = response.data.items
        .map((ite) => ({
          ...ite,
          title: ite.filename,
          ...getFileTypeInfo(ite.filename),
        }))
        .sort((a, b) => a.projectTag.id - b.projectTag.id);
      console.log(this.files);
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
